import { ButtonBasic, InputDinamycPlaceholder } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from "../../ModalComponent/ModalComponent";
import './ModalNewNameScenario.scss'

const ModalNewNameScenario = ({
    setIsModal,
    setValueName,
    valuename = '',
    createRuleCategory,
    changeRuleCat,
    fetchRuleNew,
    setIsCreateCategory,
    setIsEditId,
    isEditId
}) => {

    return (
        <ModalComponent
            title={!isEditId ? 'Создание категории' : 'Редактирование категории'}
            onClose={(e) => {
                setIsCreateCategory(false)
                setIsEditId(null)
                setIsModal(false)
            }}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-new-name-scenario'>
                    <InputDinamycPlaceholder
                        changeValue={valuename}
                        onChange={setValueName}
                        placeholder='Введите название категории'
                        size='s'
                    />

                    < ButtonBasic
                        green
                        text='Сохранить'
                        onClick={(e) => {
                            if (isEditId) {
                                changeRuleCat(e)
                                setTimeout(() => fetchRuleNew(), 500)
                                setIsCreateCategory(false)
                            } else {
                                createRuleCategory()
                            }
                            setIsEditId(null)
                            setIsModal(false)
                        }}
                    />
                </div>
            }
        />
    )
}

export { ModalNewNameScenario }